import script from "./CaptchaInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CaptchaInput.vue?vue&type=script&setup=true&lang=js"

import "./CaptchaInput.vue?vue&type=style&index=0&id=5e7812f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e7812f1"]])

export default __exports__